<template>
  <div class="wapper service mid-width">
    <div class="title">
        诉讼业务
    </div>
    <div class="list_gray" v-for="item in teamList" :key="item.index">
      <div class="list_content mid-width" :style="{'backgroundImage': `url(${item.imgUrl})`}">
        <div class="text_title">{{item.name}}</div>
        <p>{{item.describe}}</p>
        <div class="price_box">
          <!-- <span class="price">服务价格 {{item.price}} +</span> -->
          <!-- <a class="ask" href="#">在线咨询</a> -->
        </div>
      </div>
    </div>

    <button class="btn loadMore" @click="loadMore" v-show="currentPage !== totalPage">{{moreText}}</button>
  </div>
</template>

<script>
import Api from '@/common/api/api'
export default ({
  data() {
    return {
      teamList: [],
      currentPage: 1,
      totalPage: 0,
      isClick: false,
      moreText: '加载更多'
    }
  },
  created() {
    this.teamData()
  },
  methods: {
    teamData() {
      Api.lawyerProduct({
        page: this.currentPage,
        limit: 5,
        //typeId: '2'
      }).then((response) => {
        console.log(response)
        if (response.data.code === 0) {
          response.data.page.list.forEach(element => {
            this.teamList.push(element)
          })
          console.log(this.teamList)
          this.currentPage = response.data.page.currPage
          this.totalPage = response.data.page.totalPage
        }
        this.moreText = '加载更多'
        this.isClick = false
      })
      .catch((error) => {
        console.log(error);
      });
    },
    loadMore() {
      if(!this.isClick) {
        this.isClick = true
        this.currentPage++
        this.moreText = '加载中'
        this.teamData()
      }
      
    }

  }
})
</script>
<style lang="scss" scoped>
  @import '~@/common/css/common';
  .wapper {
    padding-bottom: 0px;
    padding-top: 0px;
  }
  .service {
    font-size: 15px;
    color: #666;
    padding-bottom: 30px;
    .title {
      margin-top: 20px;
      width: 100%;
      height: 250px;
      background: url("./s_bg1.jpg") no-repeat;
      background-size:100% 100%;
      text-align: left;
      padding-left: 30px;
      padding-top: 30px;
      //line-height: 250px;
      font-size: 28px;
      color: #ffffff;
    }
    .text_title {
      font-size: 18px;
      color: #333;
      line-height: 35px;
    }
    p {
      line-height: 38px;
    }
    .price_box {
      position: absolute;
      left: 370px;
      bottom: 0;
      .price {
        float: left;
        text-align: center;
        height: 50px;
        line-height: 50px;
        color: #fff;
        font-weight: bold;
        width: 280px;
        background: rgba(32, 160, 254, 1)
      }
      .ask {
        color: #333;
        float: left;
        height: 50px;
        line-height: 50px;
        margin-left: 35px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .list_gray {
      // background: #f6f5f5;
      background: #fff;
      padding: 45px 0;
      line-height: 28px;
      .list_content {
        height: 250px;
        padding-left: 370px;
        background: url("./img0.jpg") no-repeat left center;
        background-size: 320px 250px;
        position: relative;
      }
    }
    // .list_gray:nth-child(2n){
    //   background: #fff;
    //   padding: 45px 0;
    //   line-height: 28px;
    //   //margin: 25px 0;
    //   border-top: 1px solid #f6f5f5;
    //   border-bottom: 1px solid #f6f5f5;
    //   .list_content {
    //     height: 250px;
    //     padding-left: 0;
    //     padding-right: 370px;
    //     background: url("./img1.png") no-repeat right center;
    //     background-size: 320px 250px;
    //     position: relative;
    //   }
    //   .price_box {
    //     left: 0;
    //   }
    // }
    .loadMore {
      font-size: 14px;
      border: 1px solid #20A0FE;
      color: #20A0FE;
      font-weight: bold;
      display: block;
      margin: 30px auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/service/service.vue